export default __webpack_public_path__ + "static/michael clawson-dc8aec14641850bafcbe62b6d2c6648c.webp";